import script from "./list-slug.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-slug.vue?vue&type=script&setup=true&lang=ts"

import "./list-slug.vue?vue&type=style&index=0&id=e1155152&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1155152"]])

export default __exports__